export interface CmsDirectDebitInstructionConfirmation {
  directDebitInstructionConfirmationBody: string;
  directDebitInstructionConfirmationTitle: string;
}
